/**
 * Optional metadata for screen-capture attachments.
 * When present, the send pipeline can inject context (URL, resolution, etc.) into the message.
 */
export interface ScreenCaptureMeta {
  source: "screen-capture";
  /** Page URL when capturing a tab (if available). */
  url?: string;
  /** e.g. "1920x1080". */
  resolution?: string;
  /** navigator.userAgent (short). */
  userAgent?: string;
}

export interface ScreenCaptureAttachment {
  type: "image";
  data: string;
  filename: string;
  meta?: ScreenCaptureMeta;
}

/** Suggested prompts when user attaches a screenshot (for auto-prompt UX). */
export const SCREEN_CAPTURE_SUGGESTIONS = [
  "What's wrong with this UI?",
  "Explain this error message.",
  "Turn this design into Tailwind CSS.",
  "What do you see on this screen?",
  "Help me debug this.",
] as const;
